import React from 'react';
import { Link } from 'react-router-dom';
import Seo, { SITE } from '../Seo/Seo';
import ProjektanfrageButton from '../ProjectRequest/Projektanfrage';
import BlogArt from './BlogArt';
import BlogCard from './BlogCard';
import { getRelatedPosts, formatPostDate } from '../../content/blog';
import './BlogArticle.css';

/** Article page, fully generated from a post object (see src/content/blog). */
const BlogArticle = ({ post }) => {
  const related = getRelatedPosts(post, 2);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: post.title,
    description: post.excerpt,
    datePublished: post.date,
    author: { '@type': 'Organization', name: post.author },
    publisher: { '@id': `${SITE.url}/#organization` },
    mainEntityOfPage: `${SITE.url}/blogpost/${post.slug}`,
    keywords: post.tags.join(', '),
    inLanguage: 'de',
  };

  return (
    <article className="blog-article">
      <Seo
        title={`${post.title} | Nexite IT Blog`}
        description={post.excerpt}
        path={`/blogpost/${post.slug}`}
        type="article"
        jsonLd={jsonLd}
      />

      <header className="blog-article-header">
        <Link to="/blog" className="blog-article-back">
          &larr; Alle Beiträge
        </Link>
        <span className="blog-article-category">{post.category}</span>
        <h1>{post.title}</h1>
        <div className="blog-article-meta">
          <span className="blog-article-avatar" aria-hidden="true">
            {post.author.charAt(0)}
          </span>
          <span>{post.author}</span>
          <span className="blog-article-metadot" aria-hidden="true">·</span>
          <time dateTime={post.date}>{formatPostDate(post.date)}</time>
          <span className="blog-article-metadot" aria-hidden="true">·</span>
          <span>{post.readingTime} Min. Lesezeit</span>
        </div>
      </header>

      <div className="blog-article-hero">
        <BlogArt variant={post.art} size="hero" />
      </div>

      <div className="blog-article-body">
        <p className="blog-article-lead">{post.intro}</p>

        {post.sections.map((section) => (
          <section key={section.heading} className="blog-article-section">
            <h2>{section.heading}</h2>
            {(section.paragraphs || []).map((paragraph) => (
              <p key={paragraph.slice(0, 40)}>{paragraph}</p>
            ))}
            {section.bullets && (
              <ul>
                {section.bullets.map((bullet) => (
                  <li key={bullet.slice(0, 40)}>{bullet}</li>
                ))}
              </ul>
            )}
          </section>
        ))}

        <div className="blog-article-tags">
          {post.tags.map((tag) => (
            <span key={tag} className="blog-article-tag">
              #{tag}
            </span>
          ))}
        </div>

        <aside className="blog-article-cta">
          <div>
            <h2>Lassen Sie uns über Ihr Projekt sprechen</h2>
            <p>{post.cta}</p>
          </div>
          <ProjektanfrageButton />
        </aside>
      </div>

      {related.length > 0 && (
        <footer className="blog-article-related">
          <div className="blog-article-related-header">
            <h2>Das könnte Sie auch interessieren</h2>
            <Link to="/blog" className="blog-article-related-all">
              Alle Beiträge &rarr;
            </Link>
          </div>
          <div className="blog-article-related-grid">
            {related.map((relatedPost) => (
              <BlogCard key={relatedPost.slug} post={relatedPost} />
            ))}
          </div>
        </footer>
      )}
    </article>
  );
};

export default BlogArticle;
